import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { setToEditDefectCodes } from "../../store/slices/defectSlice";
import { selectInspectionIsDisabled } from "../../store/selectors/inspectionSelectors";
import { Defect } from "../../types/defect";
import { isDefaultDefectCode } from "../../utils/defectCodeHelper";

export const DefectCodeBody = (defect: Defect) => {
    const { t } = useTranslation("locale");
    const dispatch = useAppDispatch();
    const inspectionDisabled = useAppSelector(selectInspectionIsDisabled);

    const onEditDefectCode = useCallback(() => {
        dispatch(setToEditDefectCodes(defect));
    }, [defect, dispatch]);

    if (inspectionDisabled) {
        return <span>{defect.typeCode || ''}</span>;
    }

    if (isDefaultDefectCode(defect.typeCode)) {
        return (
            <span 
                className="assign-defect-code-link"
                onClick={onEditDefectCode}
            >
                {t("assignCode")}
            </span>
        );
    }

    return (
        <span 
            className="assign-defect-code-link"
            onClick={onEditDefectCode}
        >
            {defect.typeCode}
        </span>
    );
};
